// extracted by mini-css-extract-plugin
export default {"select_pill":"SelectPill_select_pill__WXdwO","spin":"SelectPill_spin__XfxQd"};